import React, { useEffect, useState } from 'react';
import axios from 'axios';

//styles
import styles from './PeyPage.module.scss';
import './multiStyles.css';
import NotFoundStyles from '../shared/NotFound.module.scss';

//shared
import MyDatePicker from '../shared/DatePicker';
import Loading from '../shared/Loading';
import NotFound from '../shared/NotFound';

//dependencys
import CopyToClipboard from 'react-copy-to-clipboard';
import moment from 'jalali-moment';

//functions
import { notify } from '../functions/hotToast';
import { changeFaToEn } from '../functions/changeFaToEn';
import { extractQueryParameters } from '../functions/queryStrings';
import Num2persian from 'num2persian';

//media
import logo5040 from '../assets/logo5040.png';
import samanKart from '../assets/samankart.jpg';
import logo50402 from '../assets/logo5040-3.png';
import vrifyLogo from '../assets/verify.png';

import Parsian from '../assets/parsian.jpg';
import Zarinpal from '../assets/zarinpal2.png';

const PayPage = () => {
  const [insertInput, setInsertInput] = useState('');
  const [updateCompo, setUpdateCompo] = useState(false);

  const [checkShowNotFound, setCheckShowNotFound] = useState(false);

  const [statusPay, setStatusPay] = useState('');
  const [offerOrNot, setOfferOrNot] = useState(false);
  const [sabtIsOk, setSabtIsOk] = useState(false);

  const [factorData, setFactorData] = useState({});

  const [isLoad, setIsLoad] = useState(true);

  const [typePeyment, setTypePeyment] = useState('online');

  const [disableBtnSend, setDisableBtnSend] = useState(false);
  const [dataOfKartBeKart, setDataOfKartBeKart] = useState({
    fourLastKart: '',
    price: '',
    fishNumber: '',
  });
  const [copyOfPrice, setCopyOfPrice] = useState('');

  const [dateVariz, setDateVariz] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [selected, setSelected] = useState();

  const querys = extractQueryParameters(window.location.href);

  console.log(querys.signature);

  const checkIsPay = querys.factor !== undefined ? true : false;
  const [gateways, setGateways] = useState([]);

  useEffect(() => {
    // const baseUrl = document.getElementById("baseUrl").value;
    const baseUrl = process.env.REACT_APP_BASE_URL;

    axios
      .get(`${baseUrl}api/factors/get-gateway-payment`)
      .then((res) => {
        if (res.data.status) {
          setGateways(res.data);
          setSelected(
            res.data.gatewayList?.find(
              (item) => item.is_default === true
            )?.value
          );
        }
      })
      .catch((error) => {
        console.log('Error fetching gateways:', error);
      });
  }, []);

  useEffect(() => {
    if (checkIsPay) {
      setIsLoad(true);
      setCheckShowNotFound(false);

      const baseUrl = process.env.REACT_APP_BASE_URL;
      axios
        .get(`${baseUrl}api/pay/get-factor-data`, {
          params: querys.signature
            ? {
                factor: querys.factor,
                signature: querys.signature,
              }
            : {
                factor: querys.factor,
              },
        })
        .then((res) => {
          if (res.data.status) {
            const data = res.data.data;
            setFactorData(data.factor);
            setIsLoad(false);
            setStatusPay(data.factor.status);

            const { discounted_price, price } = data.factor;
            if (discounted_price !== price && discounted_price !== 0)
              setOfferOrNot(true);
          } else {
            notify(
              'شماره فاکتور اشتباه است یا مشکلی پیش آمده',
              'error',
              10000
            );
            setIsLoad(false);
            setCheckShowNotFound(true);
            console.log(res);
          }
        })
        .catch((error) => {
          notify(
            'شماره فاکتور اشتباه است یا مشکلی پیش آمده',
            'error',
            10000
          );
          setIsLoad(false);
          setCheckShowNotFound(true);
          console.log(error);
        });
    }
  }, [updateCompo]);

  // تابع تحلیل کننده اعداد
  const formatNumber = (num) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  //inputs Handler
  const inputHandler = (e) => {
    const first = changeFaToEn(e.target.value);
    if (e.target.name === 'price') {
      const inputValue = e.target.value;
      const cleanedValue = inputValue.replace(/,/g, '');
      var total = changeFaToEn(cleanedValue);
    }

    setDataOfKartBeKart({
      ...dataOfKartBeKart,
      [e.target.name]:
        e.target.name === 'price' ? formatNumber(total) : first,
    });
    if (e.target.name === 'price')
      setCopyOfPrice(first.replace(/,/g, ''));
  };

  //for checks handler
  const checksHandler = (e, type) => {
    let totalCheck;
    e.target.value === 'online'
      ? (totalCheck = 'online')
      : (totalCheck = 'kartbekart');
    setTypePeyment(totalCheck);
  };

  //fot copy numberKart
  const textToCopy = '6219867000103487';
  const handleCopy = (text, result) => {
    if (result) {
      notify('شماره کارت کپی شد', 'succ');
    }
  };

  const regexFourNumber = /^\d{4}$/;
  const regexNumbers = /^[0-9]+$/;

  const sendHandler = () => {
    setDisableBtnSend(true);
    const querys = extractQueryParameters(window.location.href);

    const baseUrl = process.env.REACT_APP_BASE_URL;

    if (typePeyment === 'online') {
      if (
        querys['factor'] === undefined ||
        querys['factor'] === '' ||
        !querys['factor']
      ) {
        notify('مشکل در ارسال به دلیل سریال فاکتور', 'error', 3000);
        setDisableBtnSend(false);
        return;
      }

      axios
        .get(
          `${baseUrl}api/pay/get-url?factor=${factorData.serial}&gateway=${selected}&signature=${querys.signature}`
        )
        .then((res) => {
          if (res.data.status) {
            const data = res.data.data;

            window.location.href = data.pay_url;
          } else {
            notify('مشکل در ارتباط با درگاه بانکی', 'error', 3000);
            console.log(res);
            setDisableBtnSend(false);
          }
        })
        .catch((error) => {
          notify('مشکل در ارتباط با درگاه بانکی', 'error', 3000);
          console.log(error);
          setDisableBtnSend(false);
        });
    } else {
      const checkFourLast = regexFourNumber.test(
        dataOfKartBeKart.fourLastKart
      );

      if (dataOfKartBeKart.fourLastKart === '') {
        notify(
          'چهار رقم آخر شماره کارت شما وارد نشده',
          'error',
          3000
        );
        setDisableBtnSend(false);
        return;
      }

      if (!checkFourLast) {
        notify(
          'چهار رقم آخر شماره کارت شما صحیح وارد نشده است',
          'error',
          3000
        );
        setDisableBtnSend(false);
        return;
      }

      if (dateVariz === '') {
        notify('تاریخ واریز وارد نشده است', 'error', 3000);
        setDisableBtnSend(false);
        return;
      }

      const checkNumber = regexNumbers.test(copyOfPrice);

      if (copyOfPrice === '') {
        notify('مبلغ واریزی وارد نشده است', 'error', 3000);
        setDisableBtnSend(false);
        return;
      }

      if (!checkNumber) {
        notify('مبلغ واریزی به درستی وارد نشده است', 'error', 3000);
        setDisableBtnSend(false);
        return;
      }

      if (dataOfKartBeKart.fishNumber === '') {
        notify('شماره فیش وارد نشده است', 'error', 3000);
        setDisableBtnSend(false);
        return;
      }

      if (
        querys['factor'] === undefined ||
        querys['factor'] === '' ||
        !querys['factor']
      ) {
        notify('مشکل در ارسال به دلیل سریال فاکتور', 'error', 3000);
        setDisableBtnSend(false);
        return;
      }

      const bodySend = {
        factor: `${factorData.serial}`,
        price: copyOfPrice,
        card: dataOfKartBeKart.fourLastKart,
        tracking: dataOfKartBeKart.fishNumber,
        payDate: `${dateVariz} 00:00:00`,
      };

      axios
        .post(`${baseUrl}api/pay/ctc-pay-data`, bodySend)
        .then((res) => {
          if (res.data.status) {
            notify('ثبت شد', 'succ');
            setSabtIsOk(true);
            setDisableBtnSend(false);
          } else {
            notify('مشکل در ثبت اطلاعات', 'error', 3000);
            console.log(res);
            setDisableBtnSend(false);
          }
        })
        .catch((error) => {
          notify('مشکل در ثبت اطلاعات', 'error', 3000);
          console.log(error);
          setDisableBtnSend(false);
        });
    }
  };

  //for convert price to string persian and toman

  const beforeToman = Number(copyOfPrice) / 10;
  const TomanPrice = Num2persian(beforeToman);

  //for offer style
  const styleNumberPrice = {
    fontSize: '1.2rem',
    textDecoration: 'line-through',
    color: '#ffffffe5',
  };

  const styleTypePrice1 = {
    fontSize: '0.7rem',
    color: '#ffffffe5',
  };

  const insertHandler = (e) => {
    const first = changeFaToEn(e.target.value);
    setInsertInput(first);
  };

  //for inset number or serial factor in first step
  const numberOrSerialInsetHandler = (e) => {
    e.preventDefault();

    if (insertInput === '') {
      notify('سریال فاکتور را وارد کنید', 'error', 2500);
      return;
    }

    window.history.pushState(
      {},
      '',
      `${window.location.href}?factor=${insertInput}`
    );
    setUpdateCompo(!updateCompo);
  };

  const backBtn = () => {
    window.history.pushState({}, '', `/`);
    setInsertInput('');
    setUpdateCompo(!updateCompo);
  };

  return checkIsPay ? (
    !isLoad ? (
      !checkShowNotFound ? (
        sabtIsOk === false ? (
          <>
            {showModal && <div className={styles.backDrop}></div>}
            <div className="mainContainer container">
              {statusPay === 0 ? (
                <div className="childContainer container-fluid">
                  <img
                    src={logo5040}
                    alt="logo5040"
                    className={styles.logo5040Mobile}
                  />

                  <div className={styles.topInfo}>
                    <span>{`نام کارشناس: ${factorData.operator}`}</span>
                    <span>
                      تاریخ ثبت:{' '}
                      <span>
                        {moment(
                          factorData.created_date,
                          'jYYYY-jMM-jDD HH:mm:ss'
                        )
                          .locale('fa')
                          .format('YYYY/MM/DD HH:mm:ss')}
                      </span>
                    </span>
                  </div>

                  {/*<div className={styles.titlePage}>*/}

                  {/*    <span>فاکـتـور خـریـد</span>*/}

                  {/*</div>*/}

                  <div className={styles.price}>
                    {offerOrNot && (
                      <span className={styles.textPrice}>
                        مبلغ فاکتور با تخفیف:
                      </span>
                    )}
                    {!offerOrNot && (
                      <span className={styles.textPrice}>
                        مبلغ فاکتور:
                      </span>
                    )}

                    <div>
                      <div className={styles.divOfferOrNot}>
                        <div className="mt-4">
                          <span
                            className={styles.unmberPrice}
                            style={
                              offerOrNot === false
                                ? {}
                                : styleNumberPrice
                            }
                          >
                            {offerOrNot === false
                              ? Number(
                                  factorData.price / 10
                                ).toLocaleString()
                              : (
                                  Number(factorData.price / 10) +
                                  Number(
                                    factorData.discounted_price / 10
                                  )
                                ).toLocaleString()}
                          </span>
                          <span
                            className={styles.typePrice1}
                            style={
                              offerOrNot === false
                                ? {}
                                : styleTypePrice1
                            }
                          >
                            تومان
                          </span>
                        </div>

                        {offerOrNot && (
                          <div>
                            <span className={styles.offerPrice}>
                              {Number(
                                factorData.price / 10
                              ).toLocaleString()}
                            </span>
                            <span className={styles.typePrice2}>
                              تومان
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className={styles.bottomPage}>
                    <div className={styles.choose}>
                      <div className={styles.table_component}>
                        <table>
                          <tr>
                            <th style={{ width: '50px' }}>ردیف</th>
                            <th>لیست محصولات</th>
                          </tr>
                          {factorData.products.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td
                                  style={{
                                    width: '50px',
                                    textAlign: 'center',
                                  }}
                                >
                                  {index}
                                </td>
                                <td>{item}</td>
                              </tr>
                            );
                          })}
                        </table>
                      </div>

                      <div
                        data-bs-toggle="collapse"
                        data-bs-target={
                          typePeyment === 'kartbekart'
                            ? '#collapsKartbeKart'
                            : ''
                        }
                        role="button"
                      >
                        <label className="conRadio btn btn-danger my-2">
                          <i className="bi bi-gender-male ms-1 "></i>
                          <span>پرداخت به صورت آنلاین</span>
                          <input
                            type="radio"
                            name="typePeyment"
                            checked={
                              typePeyment === 'online' && 'checked'
                            }
                            value="online"
                            onChange={checksHandler}
                          />
                          <span className="checkmark2"></span>
                        </label>
                      </div>
                      {typePeyment === 'online' && (
                        <>
                          <p
                            style={{
                              fontSize: '14px',
                              marginTop: '20px',
                              marginRight: '10px',
                            }}
                          >
                            {' '}
                            درگاه مورد نظر خود را انتخاب کنید:
                          </p>
                          <div
                            style={{
                              display: 'flex',
                              gap: '1rem',
                              justifyContent: 'center',
                              marginBottom: '20px',
                            }}
                          >
                            {gateways?.gatewayList?.map((option) => (
                              <span>
                                <label
                                  className={`flex flex-col items-center p-4 rounded-2xl border cursor-pointer transition hover:shadow-md ${
                                    selected === option.value
                                      ? 'border-blue-500 bg-blue-50'
                                      : 'border-gray-300'
                                  }`}
                                  style={{
                                    width: '140px',
                                    justifyContent: 'center',
                                    textAlign: 'center',
                                  }}
                                >
                                  <img
                                    src={
                                      option.value === 'zarinpal'
                                        ? Zarinpal
                                        : Parsian
                                    }
                                    alt={option.value}
                                    style={{
                                      width: '100px',
                                      height: '100px',
                                      objectFit: 'contain',
                                    }}
                                  />
                                  <span className="mt-2 text-lg font-medium">
                                    {option.name}
                                  </span>
                                  <input
                                    type="radio"
                                    name="payment"
                                    value={option.value}
                                    checked={
                                      selected === option.value
                                    }
                                    onChange={() =>
                                      setSelected(option.value)
                                    }
                                    className="hidden"
                                    style={{ marginRight: '10px' }}
                                  />
                                </label>
                              </span>
                            ))}
                          </div>
                        </>
                      )}

                      <div
                        data-bs-toggle="collapse"
                        data-bs-target={
                          typePeyment === 'online'
                            ? '#collapsKartbeKart'
                            : ''
                        }
                        role="button"
                      >
                        <label className="conRadio btn btn-danger my-2">
                          <i className="bi bi-gender-female ms-1"></i>
                          <span>ثبت پرداخت کارت به کارت</span>
                          <input
                            type="radio"
                            name="typePeyment"
                            checked={
                              typePeyment === 'kartbekart' &&
                              'checked'
                            }
                            value="kartbekart"
                            onChange={checksHandler}
                          />
                          <span className="checkmark2"></span>
                        </label>
                      </div>

                      {typePeyment === 'online' && (
                        <div className={styles.descriptionOnline}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="1.3em"
                            height="1.3em"
                            viewBox="0 0 48 48"
                          >
                            <g
                              fill="none"
                              stroke="#069e15ce"
                              stroke-linejoin="round"
                              stroke-width="4"
                            >
                              <path d="M24 44a19.94 19.94 0 0 0 14.142-5.858A19.94 19.94 0 0 0 44 24a19.94 19.94 0 0 0-5.858-14.142A19.94 19.94 0 0 0 24 4A19.94 19.94 0 0 0 9.858 9.858A19.94 19.94 0 0 0 4 24a19.94 19.94 0 0 0 5.858 14.142A19.94 19.94 0 0 0 24 44Z" />
                              <path
                                stroke-linecap="round"
                                d="m16 24l6 6l12-12"
                              />
                            </g>
                          </svg>
                          <span className="p-2">
                            لطفاً نوع پرداخت خود را انتخاب کرده و بر
                            روی دکمه تأیید و نهایی کردن سفارش در پایین
                            صفحه کلیک کنید.
                          </span>
                        </div>
                      )}

                      <div
                        className="collapse"
                        id="collapsKartbeKart"
                      >
                        <div
                          className={`card card-body ${styles.kartPart}`}
                        >
                          <div className={styles.description}>
                            <p className="d-block">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="1.3em"
                                height="1.3em"
                                viewBox="0 0 48 48"
                              >
                                <g
                                  fill="none"
                                  stroke="#069e15ce"
                                  stroke-linejoin="round"
                                  stroke-width="4"
                                >
                                  <path d="M24 44a19.94 19.94 0 0 0 14.142-5.858A19.94 19.94 0 0 0 44 24a19.94 19.94 0 0 0-5.858-14.142A19.94 19.94 0 0 0 24 4A19.94 19.94 0 0 0 9.858 9.858A19.94 19.94 0 0 0 4 24a19.94 19.94 0 0 0 5.858 14.142A19.94 19.94 0 0 0 24 44Z" />
                                  <path
                                    stroke-linecap="round"
                                    d="m16 24l6 6l12-12"
                                  />
                                </g>
                              </svg>
                              <span className="p-2">
                                لطفاً نوع پرداخت خود را انتخاب کرده و
                                بر روی دکمه تأیید و نهایی کردن سفارش
                                در پایین صفحه کلیک کنید.
                              </span>
                            </p>
                            <p>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="1.3em"
                                height="1.3em"
                                viewBox="0 0 48 48"
                              >
                                <g
                                  fill="none"
                                  stroke="#069e15ce"
                                  stroke-linejoin="round"
                                  stroke-width="4"
                                >
                                  <path d="M24 44a19.94 19.94 0 0 0 14.142-5.858A19.94 19.94 0 0 0 44 24a19.94 19.94 0 0 0-5.858-14.142A19.94 19.94 0 0 0 24 4A19.94 19.94 0 0 0 9.858 9.858A19.94 19.94 0 0 0 4 24a19.94 19.94 0 0 0 5.858 14.142A19.94 19.94 0 0 0 24 44Z" />
                                  <path
                                    stroke-linecap="round"
                                    d="m16 24l6 6l12-12"
                                  />
                                </g>
                              </svg>
                              <span className="p-2">
                                پس از پرداخت به شماره کارت زیر به نام
                                باغ دارو سبز سلامت گستر پنجاه چهل،
                                چهار رقم آخر کارت خود را به همراه مبلغ
                                و تاریخ واریز در کادرهای مشخص شده وارد
                                کنید تا فاکتور شما در اسرع وقت بررسی
                                شود.
                              </span>
                            </p>
                          </div>

                          <div className={styles.notifToCopy}>
                            <span>روی کارت کلیک کنید تا کپی شود</span>
                          </div>

                          <CopyToClipboard
                            text={textToCopy}
                            onCopy={handleCopy}
                          >
                            <div className={styles.samankart}>
                              <img src={samanKart} alt="samanBank" />

                              <div className={styles.dataCartNumbers}>
                                <div className={styles.numbers}>
                                  <span>6219</span>
                                  <span>8670</span> <span>0010</span>
                                  <span>3487</span>
                                </div>
                              </div>

                              <div className={styles.dataCartName}>
                                <div className={styles.name}>
                                  باغ دارو سبز سلامت گستر پنجاه چهل
                                </div>
                              </div>
                            </div>
                          </CopyToClipboard>

                          <div className={styles.inputs}>
                            <div className={styles.fourLast}>
                              <label
                                htmlFor="LastNumber"
                                id={styles.label1}
                              >
                                چهار رقم آخر شماره کارت شما:
                              </label>

                              <div className={styles.myKart}>
                                <input
                                  type="text"
                                  placeholder="- - - -"
                                  id="LastNumber"
                                  maxLength={4}
                                  name="fourLastKart"
                                  value={
                                    dataOfKartBeKart.fourLastKart
                                  }
                                  onChange={inputHandler}
                                  style={
                                    dataOfKartBeKart.fourLastKart
                                      .length === 4
                                      ? {
                                          border: '#069e15 2px solid',
                                        }
                                      : {}
                                  }
                                />
                                <input
                                  type="text"
                                  placeholder="x x x x"
                                  disabled
                                />
                                <input
                                  type="text"
                                  placeholder="x x x x"
                                  disabled
                                />
                                <input
                                  type="text"
                                  placeholder="x x x x"
                                  disabled
                                />
                              </div>
                            </div>

                            <div className={styles.dateVariz}>
                              <label>
                                تاریخ واریز (تاریخ موجود در رسید
                                واریزی):
                              </label>
                              <MyDatePicker setDate={setDateVariz} />
                            </div>

                            <div className={styles.priceVariz}>
                              <label>مبلغ واریز (ریال):</label>
                              <input
                                type="text"
                                className={styles.myInputs}
                                name="price"
                                value={dataOfKartBeKart.price}
                                onChange={inputHandler}
                              />
                              {TomanPrice !== 'صفر' && (
                                <span
                                  id={styles.TomanWords}
                                >{`${TomanPrice} تومان`}</span>
                              )}
                            </div>

                            <div className={styles.priceVariz}>
                              <label>شماره فیش (کد رهگیری):</label>
                              <input
                                type="text"
                                className={styles.myInputs}
                                name="fishNumber"
                                value={dataOfKartBeKart.fishNumber}
                                onChange={inputHandler}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/*{typePeyment === "online" &&*/}
                    {/*    <div class="alert alert-warning d-flex align-items-center mx-3 mb-0"*/}
                    {/*         role="alert">*/}
                    {/*        <svg xmlns="http://www.w3.org/2000/svg" className='ms-2'*/}
                    {/*             width="1.1em" height="1.1em" viewBox="0 0 12 12">*/}
                    {/*            <path fill="currentColor"*/}
                    {/*                  d="M11 6A5 5 0 1 1 1 6a5 5 0 0 1 10 0m-5.5.5V8a.5.5 0 0 0 1 0V6.5a.5.5 0 0 0-1 0M6 3.75a.75.75 0 1 0 0 1.5a.75.75 0 0 0 0-1.5"/>*/}
                    {/*        </svg>*/}
                    {/*        <div className={styles.alertOnline}>*/}
                    {/*            لطفا بعد از پرداخت صفحه خود را بازنگه دارید تا مجدد به این صفحه*/}
                    {/*            منتقل شوید.*/}
                    {/*        </div>*/}
                    {/*    </div>}*/}

                    <button
                      className={styles.btnPey}
                      onClick={() => {
                        setShowModal(true);
                        sendHandler();
                      }}
                      disabled={disableBtnSend}
                    >
                      تأیید و نهایی کردن سفارش
                      {disableBtnSend && (
                        <span
                          class="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      )}
                    </button>
                  </div>

                  <img
                    src={logo5040}
                    alt="logo5040"
                    className={styles.logo5040}
                  />
                </div>
              ) : (
                <div
                  className="childContainer container-fluid"
                  style={{
                    height: '250px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <img
                    src={logo5040}
                    alt="logo5040"
                    className={styles.insertIcon}
                  />
                  <span
                    style={{
                      color: '#fff',
                      fontSize: '1.2rem',
                      margin: '0 2rem',
                      textAlign: 'center',
                      lineHeight: '2.2rem',
                    }}
                  >
                    {statusPay === 1
                      ? `فاکتور با شماره ${querys.factor} پرداخت و در انتظار تایید می‌باشد.`
                      : `فاکتور با شماره ${querys.factor} پرداخت و تایید شده است.`}
                  </span>
                  <button onClick={backBtn} className="mt-4">
                    بازگشت
                  </button>
                </div>
              )}

              {showModal && (
                <div className={styles.modal}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="ms-2"
                    width="3em"
                    height="3em"
                    viewBox="0 0 12 12"
                  >
                    <path
                      fill="#ffc107"
                      d="M11 6A5 5 0 1 1 1 6a5 5 0 0 1 10 0m-5.5.5V8a.5.5 0 0 0 1 0V6.5a.5.5 0 0 0-1 0M6 3.75a.75.75 0 1 0 0 1.5a.75.75 0 0 0 0-1.5"
                    />
                  </svg>
                  <span
                    style={{
                      fontSize: '1.2rem',
                    }}
                  >
                    درحال انتقال به صفحه پرداخت!
                  </span>
                  <p
                    style={{
                      fontSize: '1rem',
                      textAlign: 'center',
                      marginTop: '1rem',
                    }}
                  >
                    لطفا بعد از پرداخت صفحه خود را بازنگه دارید تا
                    مجدد به این صفحه منتقل شوید.
                  </p>
                  <span
                    class="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  {/*<button className={styles.btnOk} onClick={sendHandler}*/}
                  {/*        disabled={disableBtnSend}>*/}

                  {/*    متوجه شدم*/}
                  {/*    {disableBtnSend &&*/}
                  {/*        <span class="spinner-border spinner-border-sm me-2" role="status"*/}
                  {/*              aria-hidden="true"></span>}*/}
                  {/*</button>*/}
                </div>
              )}

              <div className="circle1"></div>
              <div className="circle2"></div>
            </div>
          </>
        ) : (
          <div className="mainContainer container">
            <div
              className="childContainer container-fluid"
              style={{
                backgroundColor: '#069e15',
                color: '#fff',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: 'fit-content',
                padding: '2.5rem 2rem',
                textAlign: 'justify',
                lineHeight: '2.2rem',
              }}
            >
              <img
                src={vrifyLogo}
                alt="succsess"
                style={{
                  width: '70px',
                  height: '70px',
                  marginBottom: '1rem',
                }}
              />
              <span
                style={{
                  color: '#fff',
                  fontSize: '1.2rem',
                  textAlign: 'center',
                }}
              >
                اطلاعات پرداخت شما با موفقیت ثبت شد و در حال بررسی
                می‌باشد، نتیجه از طریق پیامک به شما اطلاع داده خواهد
                شد.
              </span>
            </div>

            <div className="circle1"></div>
            <div className="circle2"></div>
          </div>
        )
      ) : (
        <NotFound
          setUpdateCompo={setUpdateCompo}
          updateCompo={updateCompo}
        />
      )
    ) : (
      <Loading />
    )
  ) : (
    <>
      <div
        className="mainContainer container"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginTop: '4rem',
        }}
      >
        {/*<div*/}
        {/*  className={`childContainer container-fluid ${styles.getMobileOrSerial}`}*/}
        {/*>*/}
        {/*<div className={styles.getInfo}>*/}
        {/*  <img*/}
        {/*    src={logo5040}*/}
        {/*    alt="logo5040"*/}
        {/*    className={styles.insertIcon}*/}
        {/*  />*/}

        {/*  <span className={styles.titleGet}>*/}
        {/*    شـماره فاکـتـور خـود را وارد کـنیـد*/}
        {/*  </span>*/}

        {/*  <form onSubmit={numberOrSerialInsetHandler}>*/}
        {/*    <input*/}
        {/*      type="text"*/}
        {/*      className={styles.myInputs}*/}
        {/*      id={styles.inputInsert}*/}
        {/*      value={insertInput}*/}
        {/*      onChange={insertHandler}*/}
        {/*    />*/}

        {/*    <button id={styles.insetBtn} type="submit">*/}
        {/*      بررسی*/}
        {/*    </button>*/}
        {/*  </form>*/}
        {/*</div>*/}
        {/*</div>*/}
        <svg
          id={NotFoundStyles.upsetSvg}
          viewBox="0 -2 159 159"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            <path
              d="M107.161 91.8809C109.289 92.4727 111.652 92.6847 113.458 93.7986C114.549 94.471 115.548 96.803 115.174 97.9142C114.801 99.0254 112.451 100.43 111.338 100.162C109.049 99.5461 106.653 99.4332 104.316 99.8312C101.98 100.229 99.7568 101.129 97.8008 102.468C92.9823 105.678 89.3464 110.376 87.4479 115.845C86.7708 117.673 86.418 120.281 83.578 119.44C80.8159 118.623 81.3637 116.045 81.7023 113.994C83.5516 102.799 95.831 92.3406 107.161 91.8809Z"
              fill="#000000"
            ></path>
            <path
              d="M108.734 60.4001C108.034 62.2094 107.658 64.0187 106.714 65.4535C104.593 68.674 99.8746 68.4744 98.6408 64.8706C97.7239 62.1932 97.8573 58.9895 98.2528 56.1204C98.3916 55.1135 100.702 53.7356 102.024 53.7329C103.818 53.8284 105.52 54.56 106.824 55.7968C107.89 56.8321 108.099 58.7499 108.734 60.4001Z"
              fill="#000000"
            ></path>
            <path
              d="M45.648 63.7801C45.6609 59.789 47.5149 57.0181 50.1917 56.9889C52.6463 56.9625 54.9419 59.8837 55.1477 63.2959C55.3549 66.7392 53.0486 69.6536 50.0955 69.678C47.2176 69.7017 45.6358 67.6033 45.648 63.7801Z"
              fill="#000000"
            ></path>
            <path
              d="M50.5281 37.793C52.1993 39.0721 53.4168 40.0031 54.6336 40.9335C53.6856 41.8958 52.9001 43.2805 51.7483 43.7423C48.2065 45.1196 44.5974 46.3175 40.9349 47.3312C40.3411 47.5025 38.8324 46.6953 38.8426 46.3744C38.8798 45.1501 38.9902 43.2629 39.7499 42.841C43.1052 40.9775 46.6954 39.5366 50.5281 37.793Z"
              fill="#000000"
            ></path>
            <path
              d="M107.561 33.9194C110.531 35.2697 113.606 36.4431 116.406 38.0838C117.18 38.5368 117.138 40.3808 117.47 41.5868C116.281 41.9003 114.984 42.6837 113.923 42.4413C110.492 41.6119 107.107 40.604 103.782 39.4219C103.393 39.2632 103.046 39.0169 102.769 38.7021C102.491 38.3873 102.29 38.0124 102.181 37.607C102.191 37.1837 102.302 36.7691 102.506 36.3979C102.709 36.0267 102.999 35.7098 103.351 35.4741C104.502 34.9012 105.875 34.7882 107.157 34.4835L107.561 33.9194Z"
              fill="#000000"
            ></path>
            <path d="M2.95582 55.9029C-4.05401 83.4539 2.08432 107.759 21.213 128.154C21.7114 128.681 22.2186 129.208 22.7265 129.716C33.0015 139.991 45.8002 146.335 55.9419 150.75C60.2939 152.651 82.6283 154.959 88.6704 154.059C124.582 148.697 148.214 128.442 156.445 94.5564C158.017 87.9188 158.799 81.1188 158.777 74.2976C158.815 58.2289 152.049 39.5478 138.097 25.5566C136.661 24.3688 135.229 23.1384 133.845 21.946C130.842 19.3654 127.74 16.6933 124.494 14.4147C99.6958 -3.03808 73.931 -3.13625 47.917 6.119C24.3638 14.4899 9.23839 31.2439 2.95582 55.9029ZM48.0172 14.3661C70.8425 4.88063 93.7443 3.20672 116.081 17.4133C120.165 20.0135 131.054 28.8136 132.768 30.1354L132.878 30.2167L132.969 30.3176C141.683 39.5586 151.661 56.4554 151.441 73.8249C151.369 81.2521 150.363 88.6408 148.449 95.8173C142.775 116.44 129.21 131.47 106.978 141.75C84.3787 152.571 51.9677 141.631 43.3442 135.938C33.8124 129.422 25.4724 121.315 18.6887 111.972C8.04933 96.9089 5.66235 75.2565 11.3788 55.4628C14.0545 46.3235 18.7304 37.8941 25.0676 30.7859C31.4048 23.6777 39.2444 18.0689 48.0179 14.3661H48.0172Z"></path>
          </g>
        </svg>

        <span style={{ fontSize: '1.3rem' }}>
          لینک پرداخت شما اشتباه می باشد!!
        </span>
      </div>
    </>
  );
};

export default PayPage;
